<template>
	<div class="comment-files">
		<strong class="files-count">{{files.length}} {{pluralizeString}}</strong>

		<span v-if="isAdmin && files.length > 1">
			&mdash; <a href="#" @click.prevent ref="copyAllLinks">Copy All Links</a>
			<span v-show="downloadBatchLink !== undefined">
				&mdash; <a :href="downloadBatchLink" target="_blank">Download All</a>
			</span>
		</span>


		<ul>
			<comment-file v-for="file in files" :key="file.id" :file="file" />
		</ul>
	</div>
</template>

<script>
import { pluralize } from '../filters';
import CommentFile from '../components/CommentFile.vue';
import Clipboard from 'clipboard';

export default {
	name: 'comment-file-list',

	components: {
		CommentFile,
	},

	props: {
		files: {
			required: true,
		},
		downloadBatchLink: String
	},

	computed: {
		isAdmin() {
			return window.is_admin;
		},

		pluralizeString() {
			return pluralize('File', this.files.length)
		}
	},
	mounted() {
		if (this.$refs.copyAllLinks) {
			const clipboard = new Clipboard(this.$refs.copyAllLinks, {
				text: () => {
					const files = this.files?.map(file => `[${file.original_name}](${file.attachment_permalink || file.fileserver_url || file.download_permalink})`).join('\n * ')
					return 'Files: \n\n * ' + files;
				}
			});
			clipboard.on('success', () => {
				this.$parent.flashAfterCopy();
			})
		}
	},
};
</script>
